<template>
  <div>
    <div>
      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
            <span style="color:#fff;">定时任务</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
            <span style="color:#fff;">日志列表</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>

    <div class="layout-content">

      <div class="layout-content-main">

        <div class="method-wrapper">
          <div style="display:inline-block;">
            <template>
              <Input v-model="key" placeholder="bean名称" style="width: 300px"/>
            </template>
            <Button type="ghost" class="mRight mLeft" @click="showKeyList()">查询</Button>
          </div>

          <Button type="primary" class="mRight"  @click="$router.push({ name: 'timing' })">返回</Button>

        </div>

        <div class="clearfix"></div>

        <div class="table-wrapper">
          <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" ></Table >
          <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
              <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
</style>
<script>
  import api from '../../api/apinew'
  import treeCom from '../../components/tree'

  export default{
    data(){
      return {
        key:'',
        pagerData:{
          data:[],
          page:{
            //分页数
            // arrPageSize:[10,20,30,40],
            //分页大小
            pagesize:10,
            //总分页数
            pageCount:1,
            //当前页面
            pageCurrent:1,
            //总数
            totalCount:0
          }

        },
        columns7: [
          {
            title: '日志ID',
            // type: 'index',
            key:'logId',
            width: 100,
            align: 'center'
          },
          {
            title: '任务ID',
            // type: 'index',
            key:'jobId',
            width: 100,
            align: 'center'
          },
          {
            title: 'bean名称',
            key: 'beanName',
            align: 'center'
          },
          {
            title: '方法名称',
            key: 'methodName',
            align: 'center'
          },
          {
            title: '参数',
            key: 'params',
            align: 'center'
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const color = row.status === 0 ? 'success' : 'error';
              const text = row.status === 0 ? '成功' : '失败';
              return h('Button', {
                props: {
                  type: color,
                  size: 'small'
                }
              }, text);
            }
          },
          {
            title: '耗时（单位：毫秒）',
            key: 'times',
            align: 'center'
          },
          {
            title: '执行时间',
            key: 'createTime',
            align: 'center'
          }
        ],
      }
    },
    mounted:function(){
      this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
    },
    methods: {
      getLists(pageCurrent,pagesize){
        api.timingLog.getLists({
          'page':pageCurrent,
          'limit':pagesize,
        }, resp => {
          // 获取分页展示list
          this.pagerData.data = resp.page.list;
          // 获取分页总条数
          this.pagerData.page.totalCount = resp.page.totalCount;
        }, error => {

        })
      },
      // 搜索关键词
      showKeyList(){
        if(this.key == ''){
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        }else{
          // console.log('通过关键词获取列表')
          api.timingLog.getListsItem({
            'logId':this.key,
          }, resp => {
            // 获取分页展示list
            this.pagerData.data =  [resp.log];
            // 获取分页总条数
            this.pagerData.page.totalCount = 1;
            this.key = '';
          }, error => {

          })
        }
      },
      // 分页 -- 页数改变
      onChange:function(curpage){
        // alert("当前页面页码是：" + curpage);
        this.pagerData.page.pageCurrent = curpage;
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
      },
      // 分页 -- pageSize 改变
      sizeChange:function(size){
        // alert("当前页面size是：" + size);
        this.pagerData.page.pagesize = size;
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
      }
    },
    components: {treeCom}
  }
</script>



// WEBPACK FOOTER //
// timingLog.vue?7fbc27fb